import { render } from "./ExpedidosFaturados.vue?vue&type=template&id=596ac9bc&scoped=true"
import script from "./ExpedidosFaturados.vue?vue&type=script&lang=js"
export * from "./ExpedidosFaturados.vue?vue&type=script&lang=js"

import "./ExpedidosFaturados.vue?vue&type=style&index=0&id=596ac9bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596ac9bc"]])

export default __exports__